require('./hireCardSidebar.scss');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');

// @core
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKTag = require('components/commons/OKTag/OKTag');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    CREDIT_CARD_TYPE_VIA_T,
    EURO_TEXT,
    HYPHEN,
    OPEN_YOUNG_KEY,
    OPEN_YOUNG_PACK_KEY
} = require('constants/index');
const CREDIT_LABELS = [
    'selectedNameForCard',
    'selectedLimit',
    'paymentMethod',
    'paymentMethodAmount',
    'tin',
    'tae',
    'separator',
    'selectedAccount'
];
const withoutNameSelector = [
    CREDIT_CARD_TYPE_VIA_T,
];
const DEBIT_LABELS = [
    'selectedNameForCard',
    'selectedAccount'
];
const OPEN_YOUNG_PACK_LABELS = [
    'openYoungBeneficiary',
    'selectedAccount',
    'separator',
    'openYoungInterveners',
];
const OPEN_YOUNG_LABELS = [
    'openYoungBeneficiary',
    'selectedAccount',
];
const PREPAID_LABELS = [
    'selectedNameForCard',
    'selectedAccount'
];


class HireCardSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildExtraImageContent() {
        const { extraImage, immHireCardImageSelector } = this.props;
        let content;

        if (!!extraImage) {
            const extraImageSrc = immHireCardImageSelector.getIn(['extraImageById', extraImage, 'url']);
            content = (
                <div className="hire-card-sidebar__extra-image-container">
                    <img
                        src={extraImageSrc}
                        className="hire-card-sidebar__extra-image"
                    />
                </div>
            );
        }

        return content;
    }

    buildImageContent() {
        const { immHireCardImageSelector } = this.props;

        const selectedImageId = immHireCardImageSelector.get('selectedImageId');
        const fetchSuccess = immHireCardImageSelector.get('fetchSuccess');

        let content;
        if (fetchSuccess && !!selectedImageId) {
            const imgSrc = immHireCardImageSelector.getIn(['imagesById', selectedImageId, 'url']);
            const extraImageElement = this.buildExtraImageContent();

            content = (
                <div className="hire-card-sidebar__image-container">
                    {extraImageElement}
                    <img className="hire-card-sidebar__image" src={imgSrc} />
                </div>
            );
        }

        return content;
    }

    buildField(label, index) {
        if (label === 'separator') {
            return <div key={index} className="hire-card-sidebar__separator" />;
        } else {
            const value = this.getFieldValue(label);

            let valueContent;
            if (!!value) {
                valueContent = (
                    <div className="hire-card-sidebar__value">
                        {value}
                    </div>
                );
            } else {
                valueContent = (
                    <div className="hire-card-sidebar__pending-value">
                        <FormattedText value="hireCardSidebar-pendingValue" />
                    </div>
                );
            }

            return (
                <section key={index} className="hire-card-sidebar__field">
                    <FormattedText
                        value={`hireCardSidebar-${label}`}
                        className="hire-card-sidebar__label"
                    />
                    {valueContent}
                </section>
            );
        }
    }

    buildFieldsContent() {
        const {
            immHireCreditLimit,
            immHirePaymentMethod,
            type,
        } = this.props;

        switch (type) {
            case 'credit':
                return CREDIT_LABELS.map((label, index) => {
                    const CREDIT_LABELS_OPTIONAL = ['paymentMethodAmount', 'tin', 'tae'];
                    const paymentMethodType = immHirePaymentMethod.get('type');

                    if (label === 'selectedNameForCard' &&
                        withoutNameSelector.includes(immHireCreditLimit.get('productType'))) {
                        return;
                    }

                    if ((!paymentMethodType || paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE)
                        && CREDIT_LABELS_OPTIONAL.includes(label)) {
                        return;
                    }

                    return this.buildField(label, index);
                })
            case 'debit':
                return DEBIT_LABELS.map((label, index) => {
                    return this.buildField(label, index);
                });
            case OPEN_YOUNG_KEY:
                return OPEN_YOUNG_LABELS.map((label, index) => {
                    return this.buildField(label, index);
                });
            case OPEN_YOUNG_PACK_KEY:
                return OPEN_YOUNG_PACK_LABELS.map((label, index) => {
                    return this.buildField(label, index);
                });
            case 'prepaid':
                return PREPAID_LABELS.map((label, index) => {
                    return this.buildField(label, index);
                });
        }
    }

    buildOpenYoungInterveners() {
        const { immOpenYoungInterveners } = this.props;
        const interveners = immOpenYoungInterveners.map((immIntervener, index) => (
            <li
                className="hire-card-sidebar__value hire-card-sidebar__value--list-item"
                key={index}
            >
                {immIntervener.get('name')}
            </li>
        ));

        return (
            <div className="hire-card-sidebar__field">
                <FormattedText
                    className="hire-card-sidebar__label hire-card-sidebar__label--margin-top"
                    value="hireCardSidebar-hireCardSidebar_intervenerLegalRepresentative"
                />
                <ul className="hire-card-sidebar__list-container">
                    {interveners}
                </ul>
            </div>
        );
    }

    getFieldValue(label) {
        const {
            creditType,
            immAccounts,
            immGlobalVariables,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
            immOpenYoungInterveners,
            immOpenYoungPersonalData,
            selectedAccount,
            type,
            revolvingPackId,
        } = this.props;
        let paymentMethodType;

        if (type === 'credit') {
            paymentMethodType = immHirePaymentMethod.get('type');
        }

        switch (label) {
            case 'selectedNameForCard':
                if (!!immHireCardNameSelector) {
                    return immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')]);
                } else {
                    return '';
                }
            case 'openYoungBeneficiary':
                if (immOpenYoungPersonalData.get('isValid')) {
                    return `${immOpenYoungPersonalData.getIn(['name', 'value'])}
                        ${immOpenYoungPersonalData.getIn(['lastName', 'value'])} ${immOpenYoungPersonalData.getIn(['lastName2', 'value'])}`;
                } else {
                    return '';
                }
            case 'openYoungInterveners':
                if (immOpenYoungInterveners.size > 0) {
                    return this.buildOpenYoungInterveners();
                } else {
                    return '';
                }
            case 'paymentMethod':
                if (!!paymentMethodType) {
                    const paymentMethod = {
                        [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardSidebar-methodOfPaymentFullPay')}`,
                        [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardSidebar-methodOfPaymentDeferredFixedFee')}`,
                        [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardSidebar-methodOfPaymentDeferredVariableFee')}`
                    };
                    return paymentMethod[paymentMethodType];

                } else {
                    return '';
                }
            case 'paymentMethodAmount':
                if (paymentMethodType === CARD_PAYMENT_METHOD_FIXED) {
                    const amountObj = {
                        amount: immHirePaymentMethod.get('value'),
                        currency: EURO_TEXT
                    };

                    return (
                        <OneLineSymbolAmount
                            amountObject={amountObj}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(amountObj, true)}
                        />
                    );
                } else if (paymentMethodType === CARD_PAYMENT_METHOD_VARIABLE) {
                    return `${immHirePaymentMethod.get('value')} %`;
                } else {
                    return '';
                }
            case 'selectedAccount':
                if (!!selectedAccount) {
                    const immAccount = immAccounts.getIn(['byId', selectedAccount]);
                    const accountIban = getLastNChars(immAccount.get('iban'));
                    return (
                        <div>
                            <span>{immAccount.get('alias')}</span>
                            &nbsp;
                            <span>{accountIban}</span>
                        </div>
                    );
                } else {
                    return '';
                }
            case 'selectedLimit':
                if (immHireCreditLimit.get('fetchSuccess')) {
                    const amountObj = {
                        amount: immHireCreditLimit.get('creditLimit'),
                        currency: EURO_TEXT
                    };

                    return (
                        <div className="hire-card-sidebar__value--important">
                            <OneLineSymbolAmount
                                amountObject={amountObj}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(amountObj, true)}
                                trimDecimals={true}
                            />
                        </div>
                    );
                } else {
                    return '';
                }
            case 'tae':
                const taeValues = {
                    'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tae']),
                    'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_tae']),
                    'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_tae']),
                    'virtual-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tae']),
                    'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, 'aplazado_tae']),
                    'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', 'aplazado_tae']),

                };
                return taeValues[creditType];
            case 'tin':
                const tinValues = {
                    'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tin']),
                    'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_tin']),
                    'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_tin']),
                    'virtual-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tin']),
                    'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, 'aplazado_tin']),
                    'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', 'aplazado_tin']),

                };
                return tinValues[creditType];
            default:
                return '';
        }
    }

    buildAddressContent() {
        const {
            hasShippingAddress,
            immAddress,
            immProfile,
            isViaT,
            immShippingAddressList
        } = this.props;

        let content;
        const addressKey = isViaT ? 'shippingAddressViaT' : 'shippingAddress';

        if (hasShippingAddress && immAddress) {
            if (!immAddress.getIn(['country', 'value'])) {
                const shippingAddress = (immAddress.isEmpty()) ? HYPHEN : PersonalDataHelper.getHireFormattedShippingAddress(immShippingAddressList, immAddress.getIn(['country', 'value']));
                content = <p>{shippingAddress}</p>;
            } else {
                const shippingAddress = (immAddress.isEmpty()) ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immAddress);
                content = (
                    <p>{shippingAddress}</p>
                );
            }
        } else {
            if (immProfile.get('isFetching')) {
                content = <LoadingSection />;
            } else {
                const address = PersonalDataHelper.getFormattedAddress(immProfile);
                content = <p>{address}</p>;
            }
        }

        return (
            <section className="hire-card-sidebar__field">
                <FormattedText
                    value={`hireCardSidebar-${addressKey}`}
                    className="hire-card-sidebar__label"
                />
                <div className="hire-card-sidebar__value">
                    {content}
                </div>
            </section>
        );
    }

    buildCollectiveContent() {
        const { immProfile, collectiveTagData, collectiveEnabled, creditType } = this.props;
        let content;
        let tagContent = <OKTag content="colectivos-businessTag" type="identification" />
        if (collectiveTagData && collectiveTagData.collective_title) {
            tagContent = (
                <div className="product-banner__title-tag">
                    <OKTag
                        content={collectiveTagData.collective_title}
                        type="collective"
                        backgroundColor={collectiveTagData.collective_background_color}
                        textColor={collectiveTagData.collective_text_color}
                        context={"pill"}
                    />
                </div>
            )
        }
        if (collectiveEnabled && immProfile.get('isCollective')) {
            const contentKey = creditType === 'diamond' ? 'collectiveTooltipContentDiamondPack' : 'collectiveTooltipContent';
            content = (
                <div className="pull-right">
                    {tagContent}
                    <OKTooltip
                        content={`hireCardSidebar-${contentKey}`}
                        placement="bottom"
                        offset={[-143, 15]}
                    />
                </div>
            );
        }
        return content;
    }

    render() {
        const { creditType, showImage, type } = this.props;
        const fieldsContent = this.buildFieldsContent();
        const collectiveContent = this.buildCollectiveContent();
        let addressContent;
        let separatorContent;
        let imageContent;

        if (type !== 'prepaid' && creditType !== 'virtual-credit') {
            addressContent = this.buildAddressContent();
            separatorContent = <div className="hire-card-sidebar__separator" />;
        }

        if (showImage) {
            imageContent = this.buildImageContent();
        }

        return (
            <OKSectionBox className="hire-card-sidebar">
                <section>
                    {imageContent}
                    <h3 className="hire-card-sidebar__title">
                        <FormattedText value="hireCardSidebar-title" />
                        {collectiveContent}
                    </h3>
                    {fieldsContent}
                    {separatorContent}
                    {addressContent}
                </section>
            </OKSectionBox>
        );
    }
}

HireCardSidebar.defaultProps = {
    collectiveEnabled: false,
    creditType: 'open-credit',
    hasShippingAddress: false,
    isViaT: false,
    showImage: true,
    type: 'credit',
};

HireCardSidebar.propTypes = {
    collectiveEnabled: PropTypes.bool,
    collectiveTagData: PropTypes.object,
    creditType: PropTypes.oneOf(['open-credit', 'diamond', 'premium', 'revolving', 'virtual-credit']),
    extraImage: PropTypes.string,
    hasShippingAddress: PropTypes.bool,
    immAccounts: PropTypes.object.isRequired,
    immAddress: PropTypes.object,
    immShippingAddressList: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object,
    immHireCreditLimit: PropTypes.object,
    immHirePaymentMethod: PropTypes.object,
    immOpenYoungInterveners: PropTypes.object,
    immOpenYoungPersonalData: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    isViaT: PropTypes.bool,
    paymentMethod: PropTypes.string,
    revolvingPackId: PropTypes.number,
    selectedAccount: PropTypes.string,
    selectedLimit: PropTypes.string,
    showImage: PropTypes.bool,
    type: PropTypes.oneOf(['credit', 'debit', 'prepaid', OPEN_YOUNG_KEY, OPEN_YOUNG_PACK_KEY]),
};

module.exports = withFeatureToggling(HireCardSidebar);
